import { inputStyles } from "../styles/styles";
import { Grid, Button } from "@material-ui/core";
import React from "react";
import BaseWindow from "./public/BaseWindow";
import unsuccess from "../images/unsuccess.png";
import { connect } from "react-redux";

function Unsuccess(props) {
  const classes = inputStyles();
  const redirectUrl = props.unsuccess.redirectUrl;

  return (
    <BaseWindow >
      <Grid item xs={12} style={{ textAlign: "center", marginTop: 50 }}>
        <div style={{ width: "100%" }}>
          <img alt="Fibabanka" src={unsuccess} width={100} height={100} />
        </div>
        <div style={{ width: "100%" }}>
          <p> 
            <b>{(props.unsuccess.msg && props.unsuccess.msg !== "")  ? props.unsuccess.msg : "NETWORK ERROR" }</b>
          </p>
          {redirectUrl && (
            <Button
              variant="contained"
              color="primary"
              href={redirectUrl}
              size="medium"
              className={classes.button}
              style={{ marginTop: 20 }}
            >
              Firmaya Git
            </Button>
          )}
        </div>
      </Grid>
      
    </BaseWindow>
  );
}

const mapStateToProps = (state) => {
  return {
    unsuccess:state.unsuccess
  };
};

export default connect(mapStateToProps)(Unsuccess);



